$(document).ready(function () {
  window.addEventListener("scroll", () => {
    const header = document.querySelector("header");
    const headerTop = header.getBoundingClientRect().top;
    if (headerTop <= 0) {
      header.classList.add("fixed-header");
    } else {
      header.classList.remove("fixed-header");
    }
  });
  const ShopKastenSlider = $(".shop-kasten-slider");
  const FourProgressBar = $(".progressBar4");
  ShopKastenSlider.on("init", function (event, slick) {
    updateProgressBar(ShopKastenSlider, FourProgressBar);
  });
  ShopKastenSlider.on("afterChange", function (event, slick) {
    updateProgressBar(ShopKastenSlider, FourProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $FourStatus = $(".pagingInfo4");
  var $ShopKastenSlider = $(".shop-kasten-slider");
  $ShopKastenSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $FourStatus.text(i + "/" + slick.slideCount);
    }
  );
  ShopKastenSlider.slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    settings: "unslick",
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          dots: true,
          infinite: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.7,
          dots: true,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.4,
          dots: true,
        },
      },
    ],
  });
  $(document).ready(function () {
    $(".shop-kasten-lists-slider").slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 500,
      settings: "unslick",
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick",
        },
        {
          breakpoint: 1400,
          settings: {
            autoplay: true,
            infinite: true,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            autoplay: true,
            infinite: true,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            autoplay: true,
            infinite: true,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            autoplay: true,
            infinite: true,
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            autoplay: true,
            infinite: true,
            slidesToShow: 1,
          },
        },
      ],
    });
  });
  $(".hamburger").click(function () {
    $(".mobile-toggle").addClass("is-active");
    $("header").addClass("is-active");
    $("body").addClass("overflow-hidden");
  });

  $(".navbar-close .menu-close").click(function () {
    $(".mobile-toggle").removeClass("is-active");
    $("body").removeClass("overflow-hidden");

    setTimeout(function () {
      $("header").removeClass("is-active");
    }, 3000);
  });
  $(".information-box .show-more").click(function () {
    $(".information-box").each(function () {
      $(this).parent().removeClass("box-active");
    });
    $(this).parent().toggleClass("box-active");
  });
  $('.information-box .show-more').click(function () {
    var $this = $(this);
    $this.toggleClass('SeeMore');
    if ($this.hasClass('SeeMore')) {
      $this.html('<img src="https://cdn.shopify.com/s/files/1/0474/0454/8262/files/down-arrow-black.svg?v=1726293757" alt="down-arrow"> Toon minder');
    } else {
      $this.html('<img src="https://cdn.shopify.com/s/files/1/0474/0454/8262/files/down-arrow-black.svg?v=1726293757" alt="down-arrow"> Toon meer');
    }
  });
  $(".filter-modal .filter-btn").click(function () {
    $(".mobile-filter-sidebar").toggleClass("show");
  });
  $(".mobile-filter-sidebar .filter-close").click(function () {
    $(".mobile-filter-sidebar").removeClass("show");
  });
  $(window).bind("scroll", function () {
    var navHeight = $(".collection-banner").height();
    if ($(window).scrollTop() > navHeight) {
      $(
        ".collection-product-details , .all-collection-wrap .facets-wrapper"
      ).addClass("sticky");
    } else {
      $(
        ".collection-product-details , .all-collection-wrap .facets-wrapper"
      ).removeClass("sticky");
    }
  });
  const multiLevelMenu = document.querySelector(".mobile-filter-sidebar");
  $(".mobile-filter-sidebar").each(function (index, mlMenu) {
    var subMenuItems = $(mlMenu).find(".hasSubMenu");
    subMenuItems.each(function (i, subMenu) {
      $(subMenu)
        .find(".trigger")
        .on("click", function () {
          var target = $(subMenu).attr("data-target");
          $(target).addClass("active");
        });
    });
    $(".backTrigger").on("click", function () {
      var _backTrigger = this;
      $(_backTrigger).parents(".subMenu").removeClass("active");
    });
  });
  $(".home-banner-list-slider").slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    settings: "unslick",
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 1400,
        settings: {
          autoplay: true,
          infinite: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          autoplay: true,
          infinite: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          autoplay: true,
          infinite: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: true,
          infinite: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          autoplay: true,
          infinite: true,
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".product-card-related-wrap").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 2,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1.7,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  const categorieSlider = $(".categorie-slider");
  var categorieProgressBar = $(".progressBar1");
  categorieSlider.on("init", function (event, slick, currentSlide, nextSlide) {
    currentDot = $(".slick-dots .slick-active").index() + 1;
    dots = categorieSlider.find(".slick-dots li").length;
    calc = (currentDot / dots) * 100;
    categorieProgressBar
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  });
  categorieSlider.on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var currentDot = $(".slick-dots .slick-active").index() + 1;
      var dots = categorieSlider.find(".slick-dots li").length;
      var calc = (currentDot / dots) * 100;
      categorieProgressBar
        .css("background-size", calc + "% 100%")
        .attr("aria-valuenow", calc);
    }
  );
  var $status = $(".pagingInfo");
  var $categorieSlider = $(".categorie-slider");
  $categorieSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + "/" + slick.slideCount);
    }
  );
  categorieSlider.slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    autoplay: false,
    arrows: true,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
          dots: false,
          infinite: false,
          autoplay: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          dots: false,
          infinite: false,
          autoplay: false,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          dots: false,
          infinite: false,
          autoplay: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: "unslick",
      },
    ],
  });
  const BestSellerSlider = $(".best-sellers-slider");
  const secondProgressBar = $(".progressBar2");
  BestSellerSlider.on("init", function (event, slick) {
    updateProgressBar(BestSellerSlider, secondProgressBar);
  });
  BestSellerSlider.on("afterChange", function (event, slick) {
    updateProgressBar(BestSellerSlider, secondProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $SecondStatus = $(".pagingInfo2");
  var $BestSellerSlider = $(".best-sellers-slider");
  $BestSellerSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $SecondStatus.text(i + "/" + slick.slideCount);
    }
  );
  BestSellerSlider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.5,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.4,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.2,
          dots: true,
          arrows: false,
        },
      },
    ],
  });
  const $SpotlightSlider = $(".spotlight-slider");
  const $SpotlightProgressBar = $(".progressBar-spotlight");
  const $SpotlightStatus = $(".pagingInfo-spotlight");
  const $window = $(window);
  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          dots: true,
          infinite: false,
        },
      },
    ],
  };
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    if (dots > 0) {
      const calc = (currentDot / dots) * 100;
      progressBarElement
        .css("background-size", calc + "% 100%")
        .attr("aria-valuenow", calc);
    } else {
      progressBarElement
        .css("background-size", "0% 100%")
        .attr("aria-valuenow", 0);
    }
  }
  function initializeSlider() {
    $SpotlightSlider
      .on("init", function (event, slick) {
        updateProgressBar($SpotlightSlider, $SpotlightProgressBar);
        const i = (slick.currentSlide ? slick.currentSlide : 0) + 1;
        $SpotlightStatus.text(i + "/" + slick.slideCount);
      })
      .on("afterChange", function (event, slick, currentSlide) {
        updateProgressBar($SpotlightSlider, $SpotlightProgressBar);
        const i = currentSlide + 1;
        $SpotlightStatus.text(i + "/" + slick.slideCount);
      });
    $SpotlightSlider.slick(settings);
  }
  if ($window.width() <= 991) {
    initializeSlider();
  }
  $window.on("resize", function () {
    if ($window.width() > 991) {
      if ($SpotlightSlider.hasClass("slick-initialized")) {
        $SpotlightSlider.slick("unslick");
      }
      if ($SpotlightSlider2.hasClass("slick-initialized")) {
        $SpotlightSlider2.slick("unslick");
      }
    } else {
      if (!$SpotlightSlider.hasClass("slick-initialized")) {
        setTimeout(() => {
          initializeSlider();
        }, 100);
      }
      if (!$SpotlightSlider2.hasClass("slick-initialized")) {
        setTimeout(() => {
        }, 100);
      }
    }
  });
  const DiscoverFurnitureSlider = $(".discover-furniture-slider");
  const tenProgressBar = $(".progressBar10");
  const $tenStatus = $(".pagingInfo10");

  DiscoverFurnitureSlider.on("init reInit afterChange", function (event, slick, currentSlide) {
    let i = (typeof currentSlide !== 'undefined' ? currentSlide : slick.currentSlide) + 1;
    $tenStatus.text(i + "/" + slick.slideCount);
    updateProgressBar(DiscoverFurnitureSlider, tenProgressBar);
  });

  function updateProgressBar(sliderElement, progressBarElement) {
    const dots = sliderElement.find(".slick-dots li").length;
    const currentDot = sliderElement.find(".slick-dots .slick-active").index() + 1;

    if (dots > 0 && currentDot > 0) {
      const calc = (currentDot / dots) * 100;
      progressBarElement
        .css("background-size", calc + "% 100%")
        .attr("aria-valuenow", calc);
    }
  }

  DiscoverFurnitureSlider.slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 5,
          dots: true,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          dots: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.75,
          dots: true,
          infinite: false,
        },
      },
    ],
  });

  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    if (dots > 0) {
      const calc = (currentDot / dots) * 100;
      progressBarElement
        .css("background-size", calc + "% 100%")
        .attr("aria-valuenow", calc);
    } else {
      progressBarElement
        .css("background-size", "0% 100%")
        .attr("aria-valuenow", 0);
    }
  }
  function initializeSlider() {
    $SpotlightSlider
      .on("init", function (event, slick) {
        updateProgressBar($SpotlightSlider, $SpotlightProgressBar);
        const i = (slick.currentSlide ? slick.currentSlide : 0) + 1;
        $SpotlightStatus.text(i + "/" + slick.slideCount);
      })
      .on("afterChange", function (event, slick, currentSlide) {
        updateProgressBar($SpotlightSlider, $SpotlightProgressBar);
        const i = currentSlide + 1;
        $SpotlightStatus.text(i + "/" + slick.slideCount);
      });
    $SpotlightSlider.slick(settings);
  }
  if ($window.width() <= 991) {
    initializeSlider();
  }
  $window.on("resize", function () {
    if ($window.width() > 991) {
      if ($SpotlightSlider.hasClass("slick-initialized")) {
        $SpotlightSlider.slick("unslick");
      }
      if ($SpotlightSlider2.hasClass("slick-initialized")) {
        $SpotlightSlider2.slick("unslick");
      }
    } else {
      if (!$SpotlightSlider.hasClass("slick-initialized")) {
        setTimeout(() => {
          initializeSlider();
        }, 100);
      }
      if (!$SpotlightSlider2.hasClass("slick-initialized")) {
        setTimeout(() => {
        }, 100);
      }
    }
  });

  const TrendingSlider = $(".trending-slider");
  const FiveProgressBar = $(".progressBar5");
  TrendingSlider.on("init", function (event, slick) {
    updateProgressBar(TrendingSlider, FiveProgressBar);
  });
  TrendingSlider.on("afterChange", function (event, slick) {
    updateProgressBar(TrendingSlider, FiveProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $FiveStatus = $(".pagingInfo5");
  var $TrendingSlider = $(".trending-slider");
  $TrendingSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $FiveStatus.text(i + "/" + slick.slideCount);
    }
  );
  TrendingSlider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.5,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.4,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.2,
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  const SpotlightSlider2 = $(".spotlight-slider-2");
  const SixProgressBar = $(".progressBar6");
  SpotlightSlider2.on("init", function (event, slick) {
    updateProgressBar(SpotlightSlider2, SixProgressBar);
  });
  SpotlightSlider2.on("afterChange", function (event, slick) {
    updateProgressBar(SpotlightSlider2, SixProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $SixStatus = $(".pagingInfo6");
  var $SpotlightSlider2 = $(".spotlight-slider-2");
  $SpotlightSlider2.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $SixStatus.text(i + "/" + slick.slideCount);
    }
  );
  SpotlightSlider2.slick({
    settings: "unslick",
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          dots: true,
          infinite: false,
        },
      },
    ],
  });
  if ($(".product-for-slider").length > 0) {
    $(".product-for-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      asNavFor: ".product-nav-slider",
    });
  }
  var helpers = {
    addZeros: function (n) {
      if (n.length > 3) {
        return `+${n.length - 4}`;
      }
      return n < 1 ? "" + (n - 4) : "" + n;
    },
  };
  function sliderInit() {
    var $slider = $(".product-nav-slider");
    $slider.each(function () {
      var $sliderParent = $(this).parent();
      $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        asNavFor: ".product-for-slider",
        dots: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 4,
              vertical: false,
              verticalSwiping: false,
            },
          },
        ],
      });
      if ($(this).find(".item").length > 1) {
        $(this).siblings(".slides-numbers-1").show();
      }
      var sliderItemsNum = $(this).find(".slick-slide").not(".slick-cloned");
      if (sliderItemsNum.length <= 4) {
        let counter1 = $("#count-box");
        counter1.addClass("d-none");
        let counterTransform1 = $(".product-nav-slider .slick-track");
        counterTransform1.addClass("transform-none");
      }
      $sliderParent
        .find(".slides-numbers-1 .total")
        .html(helpers.addZeros(sliderItemsNum));
    });
  }
  sliderInit();
  if ($(".modal-for-slider").length > 0) {
    $(".modal-for-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      asNavFor: ".modal-nav-slider",
    });
  }
  var helper = {
    addZero: function (f) {
      const windowWidth = $(window).width();
      if (windowWidth <= 575) {
        if (f.length > 3) {
          return `+${f.length - 4}`;
        }
        return f < 1 ? "" + (f - 4) : "" + f;
      } else if (windowWidth <= 1499) {
        if (f.length > 2) {
          return `+${f.length - 3}`;
        }
        return f < 2 ? "" + (f - 3) : "" + f;
      } else {
        if (f.length > 3) {
          return `+${f.length - 4}`;
        }
        return f < 1 ? "" + (f - 4) : "" + f;
      }
    },
  };
  function ModalSliderInit() {
    var $modalSlider = $(".modal-nav-slider");
    $modalSlider.each(function () {
      var $modalSliderParent = $(this).parent();
      $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        asNavFor: ".modal-for-slider",
        dots: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 4,
              vertical: false,
              verticalSwiping: false,
            },
          },
        ],
      });
      if ($(this).find(".item").length > 1) {
        $(this).siblings(".slides-numbers-2").show();
      }
      var modalSliderItemsNum = $(this)
        .find(".slick-slide")
        .not(".slick-cloned");
      if (modalSliderItemsNum.length <= 5) {
        let counter2 = $("#count-box-2");
        counter2.addClass("d-none");
        let counterTransform2 = $(".modal-nav-slider .slick-track");
        counterTransform2.addClass("transform-none");
      }
      $modalSliderParent
        .find(".slides-numbers-2 .total-count")
        .html(helper.addZero(modalSliderItemsNum));
    });
  }
  ModalSliderInit();

  // Pijltjestoetsen in galerij-pop-up: vorige/volgende foto
  var $imageModal = $("#imageModal");
  if ($imageModal.length) {
    $imageModal.on("shown.bs.modal", function () {
      $(document).on("keydown.galleryModal", function (e) {
        if (e.key === "ArrowLeft") {
          e.preventDefault();
          $(".modal-for-slider").slick("slickPrev");
        } else if (e.key === "ArrowRight") {
          e.preventDefault();
          $(".modal-for-slider").slick("slickNext");
        }
      });
    });
    $imageModal.on("hidden.bs.modal", function () {
      $(document).off("keydown.galleryModal");
    });
  }

  if ($(".latest-product-slider").length > 0) {
    $(".latest-product-slider").slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            dots: false,
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2.5,
            dots: false,
            arrows: true,
          },
        },
        {
          breakpoint: 768,
          settings: "unslick",
        },
      ],
    });
  }
  const ReviewSlider = $(".review-card-box");
  const ProgressBarReview = $(".progressBar-reviewCard");
  ReviewSlider.on("init", function (event, slick) {
    updateProgressBar(ReviewSlider, ProgressBarReview);
  });
  ReviewSlider.on("afterChange", function (event, slick) {
    updateProgressBar(ReviewSlider, ProgressBarReview);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $ReviewStatus = $(".pagingInfo-reviewCard");
  var $ReviewSlider = $(".review-card-box");
  $ReviewSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $ReviewStatus.text(i + "/" + slick.slideCount);
    }
  );
  ReviewSlider.slick({
    settings: "unslick",
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.3,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          dots: true,
          infinite: false,
        },
      },
    ],
  });
  $.fn.setMaxDimensions = function () {
    let maxHeight = 0;
    let maxWidth = 0;
    $(this).each(function () {
      if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
      }
      if ($(this).width() > maxWidth) {
        maxWidth = $(this).width();
      }
    });
    $(this).each(function () {
      $(this).height(maxHeight);
      $(this).width(maxWidth);
    });
  };
  $(".product-nav-slider .slick-slide, .slides-numbers-1").setMaxDimensions();
  $(".modal-nav-slider .slick-slide, .slides-numbers-2").setMaxDimensions();
  $(".service-list-slider").slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".service-description-block .view-all").click(function () {
    $(".service-description-view").toggleClass("description-more");
    if ($(".service-description-block .view-all").text() == "Meer lezen") {
      $(this).text("Gelezen minder");
    } else {
      $(this).text("Meer lezen");
    }
  });
  const gallerySlider = $(".showroom-gallery-slider");
  const galleryProgressBar = $(".galleryProgressBar");
  gallerySlider.on("init", function (event, slick) {
    updateProgressBar(gallerySlider, galleryProgressBar);
  });
  gallerySlider.on("afterChange", function (event, slick) {
    updateProgressBar(gallerySlider, galleryProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $galleryStatus = $(".galleryPagingInfo");
  var $gallerySlider = $(".showroom-gallery-slider");
  $gallerySlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $galleryStatus.text(i + "/" + slick.slideCount);
    }
  );
  gallerySlider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  const RecentBlogSlider = $(".most-recent-blog-slider");
  const RecentBlogProgressBar = $(".recentBlogProgressBar");
  RecentBlogSlider.on("init", function (event, slick) {
    updateProgressBar(RecentBlogSlider, RecentBlogProgressBar);
  });
  RecentBlogSlider.on("afterChange", function (event, slick) {
    updateProgressBar(RecentBlogSlider, RecentBlogProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $RecentBlogStatus = $(".recentBlogPagingInfo");
  var $RecentBlogSlider = $(".most-recent-blog-slider");
  $RecentBlogSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $RecentBlogStatus.text(i + "/" + slick.slideCount);
    }
  );
  RecentBlogSlider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.6,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  });
  const PurchaseProductSlider = $(".shopping-card-slider");
  const PurchaseProductProgressBar = $(".purchaseProgressBar");
  PurchaseProductSlider.on("init", function (event, slick) {
    updateProgressBar(PurchaseProductSlider, PurchaseProductProgressBar);
  });
  PurchaseProductSlider.on("afterChange", function (event, slick) {
    updateProgressBar(PurchaseProductSlider, PurchaseProductProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $PurchaseProductStatus = $(".purchasePagingInfo");
  var $PurchaseProductSlider = $(".shopping-card-slider");
  $PurchaseProductSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $PurchaseProductStatus.text(i + "/" + slick.slideCount);
    }
  );
  PurchaseProductSlider.slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.6,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.2,
          dots: true,
          arrows: false,
        },
      },
    ],
  });
  function isElementVisible(el) {
    const rect = el.getBoundingClientRect();
    const vWidth = window.innerWidth || doc.documentElement.clientWidth;
    const vHeight = window.innerHeight || doc.documentElement.clientHeight;

    if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) return false;
    return true;
  }
  $(window).bind("scroll", function () {
    var navHeight = $(".product-detail-banner").height() - 20;
    const productBoxBottom = document.querySelector('.product-box-bottom');

    if ($(window).scrollTop() > navHeight) {
      if (isElementVisible(productBoxBottom)) {
        $(".product-box-main").removeClass("product-box-sticky");
      } else {
        $(".product-box-main").addClass("product-box-sticky");
      }
    } else {
      $(".product-box-main").removeClass("product-box-sticky");
    }
  });
});



$(".mobile-facets__open").click(function () {
  $("header").addClass("head-active");
});

$(document).ready(function () {

  $(".popular-series-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".deSeries-detail-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
  });
  $(".series-card-sec .series-card").slice(0, 9).show();
  $("#series-more-btn").on("click", function (e) {
    e.preventDefault();
    $(".series-card:hidden").slice(0, 9).slideDown();
    if ($(".series-card:hidden").length == 0) {
      $("#series-more-btn").css("display", "none");
    }
  });




});





document.querySelectorAll('script[type="text/lazyload"]').forEach((script) => {
  const newScript = document.createElement('script');
  newScript.text = script.textContent;
  document.body.appendChild(newScript);
});




$(document).ready(function () {
  const TrendingSlider = $(".series-slider");
  const FiveProgressBar = $(".progressBar55");
  TrendingSlider.on("init", function (event, slick) {
    updateProgressBar(TrendingSlider, FiveProgressBar);
  });
  TrendingSlider.on("afterChange", function (event, slick) {
    updateProgressBar(TrendingSlider, FiveProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $FiveStatus = $(".pagingInfo55");
  var $TrendingSlider = $(".series-slider");
  $TrendingSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $FiveStatus.text(i + "/" + slick.slideCount);
    }
  );
  TrendingSlider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.5,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.4,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.2,
          dots: true,
          arrows: false,
        },
      },
    ],
  });
});
$(document).ready(function () {
  if ($(".collection-banner .collection-list-slider").length > 0) {
    $(".collection-banner .collection-list-slider").slick({
      infinite: false,
      slidesToShow: 7,
      slidesToScroll: 1,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
});


$(document).ready(function () {
  if ($(".collection-product-list .product-list").length > 0) {
    $(".collection-product-list .product-list").not('.slick-initialized').slick({
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 500,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            autoplay: true,
            slidesToShow: 2.5,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            autoplay: true,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            autoplay: true,
            slidesToShow: 1.4,
          },
        },
        {
          breakpoint: 768,
          settings: {
            autoplay: true,
            slidesToShow: 1.5,
          },
        },
        {
          breakpoint: 576,
          settings: {
            autoplay: true,
            slidesToShow: 1,
          },
        },
      ],
    });
  }
});
$(document).ready(function () {
  if ($(".review-slider").length > 0) {
    $(".review-slider").slick({
      arrows: true,
      loop: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1000,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 447,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
});
$(document).on("click", 'span[role="button"][aria-label="Sluit de chat"]', function () {
  $crisp.push(["do", "chat:close"]);
});
$(document).on("click", '.custom_chaticon', function () {
  $(this).addClass("widget-opened");
  $crisp.push(['do', 'chat:show']);
  $crisp.push(['do', 'chat:open']);
});



